module.exports = [{"title":"Accessibility","items":[{"title":"VPAT","path":"/accessibility/vpat.html"}]}]